import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { CircleCheckBig } from 'lucide-react'
import { auth } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'
import { rememberMeStore } from '../store'

const schema = z.object({
    email: z.string().min(3, 'Obrigatório').trim().email().toLowerCase(),
})

export default function RecuperarSenha() {
    const { mutateAsync, isLoading, isSuccess } =
        auth.recuperar.mutations.useCreate()

    const rememberMe = rememberMeStore(state => state.rememberMe)

    function handleSubmit(e: z.infer<typeof schema>) {
        return mutateAsync(
            { email: e.email },
            {
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            loading={isLoading}
            schema={schema}
            onSubmit={isSuccess ? undefined : handleSubmit}
            width="lg"
            defaultValues={{ email: rememberMe?.email }}
        >
            <Dialog.Title>Recuperar senha</Dialog.Title>
            <Dialog.Content>
                <div className="flex flex-row gap-6 items-center justify-evenly w-full">
                    {isSuccess ? (
                        [
                            <CircleCheckBig
                                className="text-success size-24"
                                key="icon"
                            />,
                            <span className="text-lg" key="text">
                                Um email será enviado para você com as
                                instruções para recuperação de senha.
                                <br />
                                <span className="text-sm mt-1">
                                    Não esqueça de verificar sua caixa de spam!
                                </span>
                            </span>,
                        ]
                    ) : (
                        <FormField
                            name="email"
                            label="Email cadastrado"
                            helperText="Digite seu email para receber as instruções de recuperação de senha."
                        />
                    )}
                </div>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    {isSuccess ? 'Voltar para o login' : 'Cancelar'}
                </Dialog.Actions.SecondaryButton>
                <Dialog.Actions.PrimaryButton>
                    Enviar e-mail
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
